import {
  addOnQuantityOptions,
  canBypassTicketRequirement,
  eligibleOwnedTicketTypes,
  requiredAddOnMet
} from './addOnQuantityOptions';

export const visibleAddOns = (addOns, ticketTypes, userContext, startAtAddOns) => {
  var now = new Date();

  var ticketTypeIds = ticketTypes
    .filter((tt) => tt.quantity && tt.quantity > 0)
    .map((tt) => tt.id);

  return addOns.filter((addOn) => {
    var startTime = new Date(addOn.start_time);
    var endTime = new Date(addOn.end_time);
    var quantityOptions = addOnQuantityOptions(addOn, ticketTypes, userContext, startAtAddOns);

    var ownedTicketTypeIds = eligibleOwnedTicketTypes(addOn, userContext)
      .filter((tt) => tt.quantity && tt.quantity > 0)
      .map((tt) => tt.id);

    var matchedTicketTypeIds = ticketTypeIds
      .concat(ownedTicketTypeIds)
      .filter((id) => addOn.ticket_type_ids.includes(id));

    return (
      startTime < now
        && endTime > now
        && (quantityOptions.filter((i) => i !== 0).length > 0)
        && (!addOn.require_ticket_type || matchedTicketTypeIds.length > 0 || canBypassTicketRequirement(addOn, startAtAddOns))
        && requiredAddOnMet(addOn, addOns, userContext)
        && addOn.start_time
        && addOn.end_time
    );
  });
}
